import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useConsent } from "@/context/ConsentContext";
import useSiteConfig from "@/hooks/useSiteConfig";
import { loadGA4, trackPageView } from "@/lib/ga4";

/**
 * Mount once near the app root. Loads GA4 only when consent=accepted AND ga4_id
 * is present in /api/public/site-config. Sends page_view on every route change.
 */
export default function AnalyticsHost() {
  const { status } = useConsent();
  const { ga4_id } = useSiteConfig();
  const location = useLocation();

  useEffect(() => {
    if (status === "accepted" && ga4_id) {
      loadGA4(ga4_id);
    }
  }, [status, ga4_id]);

  useEffect(() => {
    if (status === "accepted" && ga4_id) {
      trackPageView(location.pathname + location.search);
    }
  }, [location.pathname, location.search, status, ga4_id]);

  return null;
}
